import { CardState, CardTypes } from '../types/cards'

const initialState: CardState = {
  myCards: [],
}

export const CardReducer = (state: CardState = initialState, action: any) => {
  switch (action.type) {
    case CardTypes.GET_MY_CARDS_CALL:
      return {
        ...state,
        myCards: action.payload,
      }
    default:
      return state
  }
}
